import { isUndefined } from 'utils/tsHelpers';
import { objFilterOut } from '@iterable/utils';
import { useConditionStateContext } from '../../../../contexts';
import { useConditionState } from '../../../../hooks/condition';
import { EditableCondition } from '../../../../types';

export const useOnConditionValueReset = () => {
  const { value } = useConditionStateContext();
  const { setCondition, condition } = useConditionState();
  return () => {
    if (isUndefined(value) || value === '') {
      if (condition && ('value' in condition || 'values' in condition)) {
        // remove values and value
        setCondition((condition) => {
          return objFilterOut(condition, ['values', 'value']) as EditableCondition;
        });
      }
    }
  };
};
